import { useState } from "react";

import RadioListing from "../../../../../../../components/RadioListing";
import ModalTitle from "../../../../../../../components/HexModal/ModalTitle";

import { getLabel } from "../../../../../../../hooks/use-labels";
import HexButton from "../../../../../../../ui-kit/HexButtons";

const DeliveryTypesList = ({ deliveryOptions, selectedType, onSelectType }) => {
  const [selected, setSelected] = useState(selectedType?.id || "");

  const onChange = ({ target }) => {
    setSelected(target.value);
  };

  const onNext = () => {
    onSelectType(selected);
  };

  return (
    <div className="delivery-types-list">
      <ModalTitle
        text={getLabel("deliveryTypesLabel")}
        className={"capitalize"}
      />

      <RadioListing
        options={deliveryOptions}
        value={selected}
        onChange={onChange}
        className="delivery-type-radio-listing"
      />

      <HexButton
        label={getLabel("nextLabel")}
        onClick={onNext}
        disable={!selected || (selectedType && selectedType.disabled)}
        type="primary"
        size="md"
        htmlType="submit"
        className="full-width delivery-save-button mt-24"
      />
    </div>
  );
};

export default DeliveryTypesList;
